import { useIntl } from 'react-intl';
import { useClientConfig } from 'src/hooks/useClientConfig';

import './WidgetText.sass';

const WidgetText = () => {
	const client = useClientConfig();
	const intl = useIntl();
	const [localeKey] = intl.locale.split('-');
	const browserLang = typeof navigator !== 'undefined' ? navigator.language.split('-')[0] : null;

	const localizedText =
		client?.texts?.[intl.locale] ??
		client?.texts?.[localeKey] ??
		(browserLang && browserLang !== localeKey ? client?.texts?.[browserLang] : undefined) ??
		(client?.language ? client?.texts?.[client.language] : undefined) ??
		client?.text;

	return (
		<div id="widget-text">
			<span>{localizedText}</span>
		</div>
	);
};

export default WidgetText;
